function normalize(pathname) {
    if (
        !pathname ||
        pathname === '/'
    ) {
        return '/';
    }

    return pathname
        .replace(
            /\/{2,}/g,
            '/'
        )
        .replace(
            /\/+$/,
            ''
        ) || '/';
}

function starts(
    path,
    segment
) {
    return (
        path === segment ||
        path.startsWith(
            `${segment}/`
        )
    );
}

export function resolveAnalyticsPageType(
    pathname
) {
    const path =
        normalize(
            pathname
        );

    if (path === '/') {
        return 'catalog';
    }

    if (
        starts(
            path,
            '/add'
        )
    ) {
        return 'listing';
    }

    if (
        starts(
            path,
            '/profile'
        )
    ) {
        return 'owner_profile';
    }

    if (
        path ===
        '/favourites'
    ) {
        return 'favorites';
    }

    if (
        path ===
        '/map_search'
    ) {
        return 'map_search';
    }

    if (
        path ===
        '/places'
    ) {
        return 'place_index';
    }

    if (
        [
            '/places/history',
            '/places/natural',
            '/places/architecture',
            '/places/leisure'
        ].includes(path)
    ) {
        return 'place_category';
    }

    if (
        starts(
            path,
            '/places'
        )
    ) {
        return 'place_detail';
    }

    if (
        starts(
            path,
            '/v'
        )
    ) {
        return 'selection_view';
    }

    if (
        starts(
            path,
            '/selection'
        )
    ) {
        return 'selection_create';
    }

    if (
        starts(
            path,
            '/chat'
        )
    ) {
        return 'apartment_chat';
    }

    if (
        starts(
            path,
            '/direct'
        )
    ) {
        return 'direct_chat';
    }

    if (
        starts(
            path,
            '/requestChat'
        )
    ) {
        return 'request_chat';
    }

    if (
        path ===
        '/messages'
    ) {
        return 'messages';
    }

    if (
        path ===
        '/main'
    ) {
        return 'main';
    }

    if (
        path ===
        '/blog'
    ) {
        return 'blog';
    }

    if (
        path ===
        '/about'
    ) {
        return 'about';
    }

    if (
        path ===
        '/photo_gallery'
    ) {
        return 'photo_gallery';
    }

    if (
        path ===
        '/global_reviews'
    ) {
        return 'global_reviews';
    }

    if (
        starts(
            path,
            '/owner/calendar'
        )
    ) {
        return 'owner_calendar';
    }

    if (
        starts(
            path,
            '/owner'
        ) ||

        path ===
        '/owner_analytics' ||

        path ===
        '/owner_promotions'
    ) {
        return 'owner_area';
    }

    if (
        starts(
            path,
            '/admin'
        ) ||

        path ===
        '/admin_analytics'
    ) {
        return 'admin';
    }

    if (
        starts(
            path,
            '/promotion'
        )
    ) {
        return 'promotion';
    }

    if (
        starts(
            path,
            '/payment'
        )
    ) {
        return 'payment_return';
    }

    if (
        starts(
            path,
            '/createAdd'
        ) ||

        starts(
            path,
            '/editAdd'
        ) ||

        starts(
            path,
            '/checked'
        )
    ) {
        return 'listing_management';
    }

    /*
     * В текущем router последний
     * public route — /:slug.
     */
    if (
        path
            .split('/')
            .filter(Boolean)
            .length === 1
    ) {
        return 'seo_landing';
    }

    return 'other';
}

export function resolveAnalyticsSurface(
    pathname
) {
    const pageType =
        resolveAnalyticsPageType(
            pathname
        );

    return {
        catalog:
            'catalog',

        seo_landing:
            'seo_landing',

        place_detail:
            'place_nearby',

        listing:
            'similar_listings',

        map_search:
            'map_search',

        favorites:
            'favorites',

        owner_profile:
            'owner_profile'
    }[pageType] || null;
}